<template>
  <article class="medicalFiles models">
    <div
      v-show="$refs.upload && $refs.upload.dropActive"
      class="drop-active"
    >
      <h4 class="models__title">
        Arraste o arquivo para enviar
      </h4>
    </div>

    <h4 class="models__title">
      Gerenciar Arquivos
    </h4>

    <p class="models__description">
      Digite abaixo modelos de documentos, como receitas, pedidos de exames,
      entre outros para enviar facilmente para seus pacientes em suas consultas.
    </p>

    <form @submit.prevent="submit()" class="medicalFiles__form">
      <div
        class="medicalFiles__form-wrapper"
        :class="[errorClass($v.formData.name), successClass($v.formData.name)]"
      >
        <label class="medicalFiles__form-label">
          Documento
        </label>

        <input
          v-model="formData.name"
          @blur="$v.formData.name.$touch()"
          placeholder="Nome do Documento"
          class="form-input"
          type="text"
        >

        <ul class="medicalFiles__form-errors">
          <li v-if="!$v.formData.name.required && $v.formData.name.$dirty">
            <span class="form-input-hint">
              campo em branco
            </span>
          </li>
        </ul>
      </div>

      <div
        class="medicalFiles__form-wrapper medicalFiles__form-wrapper--upload"
        :class="[errorClass($v.formData.file), successClass($v.formData.file)]"
      >
        <file-upload
          v-model="formData.file"
          ref="upload"
          :headers="$store.getters.getAuthHeader"
          :extensions="extensions"
          :drop-directory="true"
          :multiple="false"
          :accept="accept"
          :drop="true"
          class="medicalFiles__upload"
          @input-file="updateFile"
          @blur="$v.formData.file.$touch()"
        >
          <div class="medicalFiles__upload-wrapper">
            <dr-icon
              class="dr-icon medicalFiles__upload-icon"
              color="grey"
              fill="grey"
              name="upload"
            />

            <p class="medicalFiles__upload-description">
              Clique aqui ou arraste o seu arquivo com
              <br>
              tamanho máximo de 3 MB para essa área.
            </p>

            <ul v-if="formData.file" class="medicalFiles__upload-list">
              <li
                v-for="file in formData.file"
                :key="file.id"
                class="medicalFiles__upload-item"
              >
                <span>{{file.name}}</span>
              </li>
            </ul>
          </div>
        </file-upload>

        <ul class="medicalFiles__form-errors" v-if="!$v.$error">
          <li v-if="!$v.formData.file.required && $v.formData.file.$dirty">
            <span class="form-input-hint">
              campo em branco
            </span>
          </li>

          <li v-if="!$v.formData.file.mustBePDF && $v.formData.file.$dirty">
            <span class="form-input-hint">
              Extensão inválida. Envie um arquivo PDF
            </span>
          </li>

          <li v-for="(error, $index) in getApiErrors" :key="$index">
            <span class="form-input-hint">
              {{error}}
            </span>
          </li>
        </ul>
      </div>

      <footer class="medicalFiles__form-footer">
        <dr-submit
          :sending="sending"
          text="Salvar"
          class="btn-sm"
        />
        &ensp;
        <dr-submit
          @click="resetForm()"
          :type="'button'"
          text="Limpar"
          class="medicalFiles__new btn-sm"
        />
        &ensp;
        <template>
          <dr-submit
            v-if="formData.file[0] && !isNewFile"
            @click="showPDFModal()"
            :sending="loadingPdf"
            :type="'button'"
            text="Visualizar"
            class="btn-sm"
          />
        </template>
      </footer>
    </form>

    <div class="modal modal-lg medicalFiles__modal" :class="fileModal ? 'active' : ''" id="modal-id">
      <span
        class="modal-overlay"
        aria-label="Close"
        @click="fileModal = false">
      </span>

      <div class="modal-container">
        <div class="modal-header">
          <span
            @click="fileModal = false"
            class="btn btn-clear float-right"
            aria-label="Close"
          >
          </span>

          <div class="modal-title h5">
            {{formData.name}}
          </div>
        </div>

        <div class="modal-body">
          <div class="content" id="pdf__container">
            <!-- <embed :src="getPDF()" class="pdf-file"> -->
          </div>
        </div>

        <div class="modal-footer">
          <span class="btn btn-primary" @click="fileModal = false">
            Fechar
          </span>
        </div>
      </div>
    </div>

    <section class="models__models" v-if="files.length > 0">
      <div class="models__models-header">
        <h4 class="models__models-title">Modelos</h4>
      </div>

      <hr>

      <ul class="models__models-list">
        <li
          v-for="model in files"
          :class="(formData.file.length > 0 && formData.file[0].id === model.id) ? 'active' : ''"
          :id="`file_${model.id}`"
          :key="model.id"
          class="models__models-item"
        >
          <a class="models__models-remove" @click="deleteModel(model.id)">
            &times;
          </a>

          <img
            @click="getModel(model)"
            :src="pdf"
            class="clickable models__models-icon"
          />

          <span class="models__models-name" @click="getModel(model)">
            {{model.name}}
          </span>
        </li>
      </ul>
    </section>
  </article>
</template>

<script>
import FileUpload from 'vue-upload-component'
import drSubmit from '@/components/form/submit'
import DocumentEditor from '@ckeditor/ckeditor5-build-decoupled-document/build/ckeditor.js'
import { required } from 'vuelidate/lib/validators'
import pdf from '@/assets/img/icons/ico_png/ico_pdf.png'
import cross from '@/assets/img/icons/ico_png/ico_cross.png'

const mustBePDF = (value) => {
  if (value.length) {
    return value[0].name.search('.pdf') >= 0
  }
  return true
}
export default {
  components: {
    drSubmit,
    FileUpload
  },
  data () {
    return {
      editor: DocumentEditor,
      files: [],
      pdf: pdf,
      cross: cross,
      formData: {
        name: null,
        file: []
      },
      loadingPdf: false,
      fileModal: false,
      accept: 'application/pdf',
      extensions: 'pdf',
      sending: false,
      getApiErrors: [],
      isNewFile: true
    }
  },
  validations () {
    return {
      formData: {
        name: {required},
        file: {
          required,
          mustBePDF
        }
      }
    }
  },
  created () {
    this.fn_HIDE_PROGRESS()
    this.updateListfiles()
  },
  watch: {
    fileModal (next, old) {
      if (next === false) {
        this.removeEmbed()
      }
      return next
    },
    formData: {
      deep: true,
      handler (newFile, oldFile) {
        if (newFile.file.length > 0) {
          // Limite máximo para upload de arquivo = 3 MB (ou 3 * 1e+6)
          if (newFile.file[0].size > 3 * 1e+6) {
            this.$store.dispatch('setModalAlert', {
              title: 'Ocorreu um erro',
              body: 'O tamanho máximo do arquivo PDF é de 3 MB.',
              size: 'md',
              active: true
            })
            this.formData.file = []
          }
        }
      }
    }
  },
  methods: {
    injectEmbed (file) {
      const wrapper = document.querySelector('#pdf__container')
      const embed = document.createElement('embed')
      console.log('gadgadgad')
      embed.classList.add('pdf-file')
      embed.setAttribute('src', this.getPDF())
      wrapper.appendChild(embed)
    },
    removeEmbed () {
      const wrapper = document.querySelector('#pdf__container')
      const embed = wrapper.querySelectorAll('embed')
      for (let el of embed) {
        el.remove()
      }
    },
    getPDF () {
      if (this.formData.file.length) {
        const url = `${process.env.ROOT_API}/s3/file/medical_document/${this.formData.file[0].id}/file`
        this.$http.get(
          url,
          {
            headers: this.$store.getters.getAuthHeader.headers,
            responseType: 'blob'
          }
        )
          .then(res => this.generatePDFFile(res.data))
          .then(objURL => this.embedFile(objURL))
          // .then((embed) => {
          //   if (embed) {
          //     this.currentDocument = 'Documento'
          //     this.modalType = 'document'
          //   }
          // })
          .catch(err => console.trace(err))
      }
      return null
    },

    generatePDFFile (rawData) {
      const blob = new Blob([rawData], { type: 'application/pdf' })
      return URL.createObjectURL(blob)
    },

    embedFile (file = null) {
      if (file) {
        const wrapper = document.querySelector('#pdf__container')
        const embed = document.createElement('embed')
        embed.classList.add('pdf-file')
        embed.style.height = '70vh'
        embed.style.width = '100%'
        embed.setAttribute('src', file)
        wrapper.appendChild(embed)

        return true
      }

      return false
    },

    getModel (model) {
      this.formData.name = model.name
      this.formData.file = []
      let file = {
        id: model.id,
        name: model.file_name
      }
      this.formData.file.push(file)
      this.formData.id = model.id
      this.isNewFile = false
      if (this.fn_IS_MOBILE()) {
        document.querySelector('.medicalFiles__form-wrapper--upload')
          .scrollIntoView({
            behavior: 'smooth'
          })
      }
    },
    showPDFModal () {
      if (this.fn_IS_MOBILE()) {
        this.fn_SHOW_PROGRESS()
        this.loadingPdf = true
        const url = `${process.env.ROOT_API}/s3/file/medical_document/${this.formData.file[0].id}/file`
        this.$http.get(
          url,
          {
            headers: this.$store.getters.getAuthHeader.headers,
            responseType: 'blob'
          }
        ).then((res) => {
          var file = new Blob([res.data], {
            type: 'application/pdf'
          })
          var fileURL = URL.createObjectURL(file)
          let a = document.createElement('a')
          document.body.appendChild(a)
          a.style = 'display: none'
          a.setAttribute('download', this.formData.file[0].name)
          a.target = '_blank'
          a.href = fileURL
          a.addEventListener('click', (ev) => {
            let w = window.open(fileURL, '_blank')
          })
          a.click()
          // var win = window.open()
          // win.location = fileURL
          // console.log(win)
          // win.document.write('<iframe src="' + fileURL + '" frameborder="0" style="border:0; top:0px; left:0px; bottom:0px; right:0px; width:100%; height:100%;" allowfullscreen></iframe>')
        }
        ).catch((err) => { console.log(err) }
        ).finally(
          () => {
            this.fn_HIDE_PROGRESS()
            this.loadingPdf = false
          }
        )
        return
      }
      this.fileModal = true
      this.getPDF()
      // this.injectEmbed(this.getPDF())
    },
    resetForm () {
      this.formData = {
        name: null,
        file: []
      }
      this.isNewFile = true
      this.$v.formData.$reset()
    },
    updateListfiles () {
      this.$http.get('/doctor/medical_document?filterAnd[md.isModelDocument]=1&itensPerPage=100', this.$store.getters.getAuthHeader).then(
        (res) => {
          let { data } = res.data
          this.files = data
        }
      ).catch(
        (err) => {
          console.log(err)
        }
      ).finally(() => {
        this.loaded = true
      })
    },
    errorClass (item) {
      if ((item.$invalid && item.$dirty) || this.getApiErrors.length) {
        return 'has-error'
      }
    },
    successClass (item) {
      if (!item.$invalid) {
        return 'has-success'
      }
    },
    updateFile (file, old) {
      if (!this.formData.id) {
        return
      }
      if (!this.formData.file[0]) {
        return
      }
      if (!this.formData.file[0].fileObject) {
        return
      }
      this.sending = true
      this.apiErrors = this.fn_BUILD_API_ERRORS(this.formData)
      const data = file.file
      let headers = this.fn_COPY_OBJECT(this.$store.getters.getAuthHeader)
      let boundary = Math.random().toString().substr(2)
      headers.headers['Content-Type'] = `multipart/form-data; charset=utf-8; boundary=${boundary}`
      let formData = new FormData()
      formData.append('file[file][file]', data)
      this.fn_SHOW_PROGRESS()
      this.$http.post(`/doctor/medical_document/${this.formData.id}/file`, formData, headers).then(
        (res) => {
          let status = res.code || res.status
          if (status) {
            this.$store.dispatch('setModalAlert', {
              title: 'Sucesso',
              body: 'Arquivo atualizado!',
              size: 'md',
              active: true
            })
            this.resetForm()
          }
        }
      ).catch(
        (err) => {
          console.log(err)
          this.fn_FLATTEN_OBJECT(err.errors.children).then(
            (res) => {
              for (let field in res) {
                this.apiErrors[field.replace(/.children|.errors/g, '')] = res[field]
              }
            }
          )
          this.$store.dispatch('setModalAlert', {
            title: 'Erro',
            body: 'Ocorreu um erro, tente novamente mais tarde',
            size: 'md',
            active: true
          })
        })
        .finally(() => {
          this.updateListfiles()
          this.$v.$reset()
          this.fn_HIDE_PROGRESS()
          this.sending = false
        })
    },

    submit () {
      this.$v.$touch()
      if (
        this.$v.$invalid ||
        this.formData.file.length === 0 ||
        this.formData.file[0].name.search(this.extensions) === -1
      ) {
        if (this.formData.file.length === 0) {
          this.$store.dispatch('setModalAlert', {
            title: 'Erro',
            body: 'Você precisa escolher um arquivo antes de Salvar.',
            size: 'md',
            active: true
          })
        }

        return
      }
      let data = {
        name: this.formData.name,
        file: this.formData.file[0].file
      }
      this.sending = true
      let endpoint = '/doctor/medical_document'
      let method = 'post'
      let headers = this.$store.getters.getAuthHeader.headers
      let form = null
      if (this.formData.id) {
        headers['Content-Type'] = `application/x-www-form-urlencoded`
        endpoint = `/doctor/medical_document/${this.formData.id}`
        method = 'put'
        delete data.file
        form = `name[name]=${data.name}`
      } else {
        let boundary = Math.random().toString().substr(2)
        headers['Content-Type'] = `multipart/form-data; charset=utf-8; boundary=${boundary}`
        form = new FormData()
        form.append('medical_document[name]', data.name)
        form.append('medical_document[file][file]', data.file)
        form.append('medical_document[isModelDocument]', true)
      }
      this.fn_SHOW_PROGRESS()
      this.$http({
        url: endpoint,
        method,
        data: form,
        headers
      }).then(res => {
        let status = res.code || res.status
        if (status) {
          this.$store.dispatch('setModalAlert', {
            title: 'Sucesso',
            body: 'Dados atualizados',
            size: 'md',
            active: true
          })
        }
        this.formData.id = null
        this.formData.name = null
        this.formData.file = []
        this.resetForm()
      }).catch(err => {
        console.log(err, form)
        this.$store.dispatch('setModalAlert', {
          title: 'Erro',
          body: 'Ocorreu um erro, tente novamente mais tarde',
          size: 'md',
          active: true
        })
      }).finally(() => {
        this.$v.$reset()
        this.sending = false
        this.formData.id = null
        this.formData.name = null
        this.formData.file = []
        this.updateListfiles()
        this.fn_HIDE_PROGRESS()
      })
    },
    deleteModel (id) {
      const self = this
      this.$store.dispatch('setModalConfirm', {
        title: 'Confirmação',
        body: `Tem certeza que deseja remover o arquivo? <br> <small>Esta ação não poderá ser revertida.</small>`,
        confirmText: 'Confirmar',
        cancelText: 'Cancelar',
        beforeClose (v) {
          if (!v) {
            this.$store.dispatch('setModalConfirm')
          } else {
            this.fn_SHOW_PROGRESS()
            this.$http.delete(`/doctor/medical_document/${id}`, this.$store.getters.getAuthHeader)
              .then(res => {
                let status = res.code || res.status
                if (status) {
                  this.$store.dispatch('setModalAlert', {
                    title: 'Sucesso',
                    body: 'Removido com sucesso',
                    size: 'md',
                    active: true
                  })
                  self.resetForm()
                }
              })
              .catch(err => {
                console.log(err)
                this.$store.dispatch('setModalAlert', {
                  title: 'Erro',
                  body: 'Ocorreu um erro, tente novamente mais tarde',
                  size: 'md',
                  active: true
                })
              })
              .finally(() => {
                self.fn_HIDE_PROGRESS()
                self.$store.dispatch('setModalConfirm')
                self.updateListfiles()
              })
          }
        },
        size: 'md',
        active: true
      })
    },
    setCid ($value) {
      if ($value) {
        this.formData.description = this.formData.description.replace(/#CID-X/g,
          `CID-${$value}, #CID-X `)
      }
    }
  }
}
</script>
